import { type MinionOutput, type MinionOutputItem } from './types';

/**
 * Extracts the MinionOutputItem from a MinionOutput which can be
 * either a single item or an array of items.
 */
export const getMinionOutputItem = (minion: MinionOutput): MinionOutputItem => {
	return Array.isArray(minion) ? minion[0] : minion;
};
